export const API_URL =
  "https://eth-goerli.g.alchemy.com/v2/Hm-ypsVgaQQjBBDotNpt8GNka3c_H-Vf";
export const PRIVATE_KEY =
  "e048f64f46ec975b4145f27cc9c490eee044d46f5ff3a464f799c564c472c3c7";
export const ETHERSCAN_API_KEY = "WH318ACFHXTJ94FDVA9ZXYGK4JT411V5V6";
